module.exports                     = require('./src/index');
if(global.SERVER) {
    module.exports.MigrationController = require('./migrations/index');
}
